<template>
  <div class="date_box">
    <el-date-picker
     v-model="dateRange" type="datetime" placeholder="选择日期时间" clearable @change="changes" @input="input()"></el-date-picker>
    <i class="el-icon-date data_icon"></i>
  </div>
</template>

<script>
export default {
  name: 'DateBox',
  props:{
	  dateRange:String
  },
  data() {
	  return{
		  // dateRange:''
	  }
  },
  methods: {
      changes(val) {
          this.$emit('change', val);
      },
	  
	  input() {
	        this.$forceUpdate();
	  },
  }
}
</script>


<style lang="scss" scoped>
  // 穿刺写法
  ::v-deep .el-input__icon {
    display: none;
  }
  ::v-deep .el-input--prefix .el-input__inner{
	  padding-left: 15px;
  }
  .date_box {
    position: relative;
    width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
    .data_icon {
      position: absolute;
      top: 50%;
      right: 17px;
      z-index: 9;
      color: #c0c4cc;
      font-size: 14px;
      transform: translateY(-50%);
    }
    ::v-deep .el-range__close-icon {
      position: absolute;
      right: 34px;
      top: 54%;
      transform: translateY(-50%);
    }
  }
</style>